import { render, staticRenderFns } from "./Hospital.vue?vue&type=template&id=65b266cf&scoped=true"
import script from "./Hospital.vue?vue&type=script&lang=js"
export * from "./Hospital.vue?vue&type=script&lang=js"
import style0 from "./Hospital.vue?vue&type=style&index=0&id=65b266cf&prod&lang=scss&scoped=true"
import style1 from "./Hospital.vue?vue&type=style&index=1&id=65b266cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b266cf",
  null
  
)

export default component.exports